import { client } from "./client";

type Config = {
  id: string;
  ret: string;
  ContactArea: string;
};

export const getContactToken = async (data: Config) => {
  const response = await client.post<{ token: string }>(
    "/authenticate/json/v2",
    undefined,
    {
      headers: {
        ContactArea: data.ContactArea,
        context: data.ContactArea,
        Remember: "true",
      },
      auth: {
        username: data.id,
        password: data.ret,
      },
    }
  );

  return response.data.token;
};

